import { useCallback } from 'react';
import { useSound as useSoundContext } from '../contexts/SoundContext';
import { type SoundName } from '../utils/soundManager';

/**
 * Hook for playing sounds in components
 * Returns a play function for the specified sound
 */
export const useSoundEffect = (soundName: SoundName) => {
  const { playSound } = useSoundContext();

  const play = useCallback((volume?: number) => {
    playSound(soundName, volume);
  }, [soundName, playSound]);

  return play;
};